import {useTranslation} from 'react-i18next';
import {useRemoteAccessEnv} from '../env';
import {useFetchLockConditions} from './useFetchLockConditions';

function useAvailableLocks() {
  const {housing} = useRemoteAccessEnv();
  const {t} = useTranslation();

  const {data: lockConditions, isLoading: areLockConditionsLoading} =
    useFetchLockConditions();

  const incompleteConditions =
    lockConditions?.incomplete_conditions.map(condition =>
      t(`remote_access_incomplete_conditions.${condition}`),
    ) || [];

  const areKeysAvailable = Boolean(
    incompleteConditions?.length === 0 && lockConditions && lockConditions?.is_available,
  );

  return {
    incompleteConditions,
    areKeysAvailable,
    areLockConditionsLoading: areLockConditionsLoading || !housing?.id,
    lockConditions,
  };
}

export {useAvailableLocks};
